/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileWordLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileWordLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40.667 23 22 25.667v24.889l18.667 2.666v-2.666H53.2a.8.8 0 0 0 .8-.8v-23.29a.8.8 0 0 0-.8-.8H40.667V23Z",
        fill: "#2B579A"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M40.666 27.444h11.556v21.333H40.666z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#2B579A",
        d: "M39.778 30.111h9.778v1.778h-9.778zm0 5.333h9.778v-1.778h-9.778zM38.889 39h10.667v-1.778H38.889zm0 3.556h10.667v-1.778H38.889zm.889 3.555h9.778v-1.778h-9.778z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m38 32.778-2.5 10.666h-2.36l-1.57-6.843a6.387 6.387 0 0 1-.151-1.197h-.027a8.164 8.164 0 0 1-.17 1.197l-1.61 6.843h-2.46l-2.486-10.666h2.328l1.332 7.104c.057.302.1.709.125 1.22h.04c.018-.382.081-.799.191-1.25l1.715-7.074h2.281l1.55 7.163c.057.263.108.645.152 1.145h.026c.018-.391.064-.788.139-1.19l1.305-7.118H38Z",
        fill: "#fff"
      }
    )
  );
};
export {
  FileWordLarge
};
